<template>
    <!-- 签约管理card -->
    <div class="appointment-card">
        <div class="appointment-card-body">
            <div class="clear">
                <div class="left">
                    <avatar-box class="left" :avatar="item.user.largeAvatar" :auth="item.is_vip" style="margin-right:0.1rem"></avatar-box>
                    <div class="appointment-card-body__info left fs2">
                        <div class="name">{{item.user.nickname}}</div>
                        <div class="mtn">《{{item.title}}》</div>
                        <div class="fs2 c9 mtn">
                            上课时间：{{starttime}}~{{endtime}}
                        </div>
                    </div>                    
                </div>
                <div class="fs2 right appointment-card-body__btn">
                    <!-- used状态：超过预约的时间 自动判断为used -->
                    <van-button v-if="item.status=='used'" type="primary" size="mini" @click="signIn(item.id,'signed')">签卡</van-button>
                    <div v-if="item.status=='applying'">
                        <van-button type="warning" size="mini" plain style="width:auto;padding:0 0.05rem;" @click="refuseshow=true">取消预约</van-button>
                        <van-button type="primary" size="mini" style="width:auto;padding:0 0.05rem;" @click="signIn(item.id,'passed')">同意预约</van-button>
                    </div>
                    <van-button v-else-if="item.status=='signed'" class="c9" size="mini">已签卡</van-button>
                    <span v-else-if="item.status=='passed'" class="c9 mrn">已确认预约</span>
                    <span v-else-if="item.status=='canceled'" class="c9 mrn">已取消</span>
                    <span v-else-if="item.status=='refused'" class="red mrn">已拒绝</span>
                </div>                
            </div>
        </div>
        <!-- 取消预约 -->
        <van-dialog
            v-model="refuseshow"
            title="取消预约"
            show-cancel-button
            confirm-button-text="确认取消"
            :before-close="cancelSign"
            >
            <van-field
                v-model="refusedReason"
                class="mtm"
                type="text"
                placeholder="请输入取消原因"
            />
        </van-dialog>
    </div>
    <!-- appointment-card -->
</template>
<script>
import Vue from 'vue';
import moment from 'moment';
import { Toast } from 'vant';
import AvatarBox from '@/components/AvatarBox'
moment.locale('zh-cn');
Vue.use(Toast);

export default {
    name: 'AppointmentCard',
    components: {    
        AvatarBox
    },
    props:[
        "item"
    ],
    data(){
        return {
            starttime: moment(this.item.startTime*1000).format('YYYY-MM-DD HH:mm'),
            endtime:moment(this.item.endTime*1000).format('HH:mm'),
            classobject:'appointment-card-body__status--success',
            refuseshow:false,
            refusedReason:''
        }
    },
    methods:{
        mystatus(status){
            if(status=='applying'){
                return '等待俱乐部确认'
            }else if(status=='passed'){
                return '预约成功'
            }else if(status=='refused'){
                this.classobject="appointment-card-body__status--fail"
                return '预约失败'
            }else if(status=='canceled'){
                this.classobject="c9"
                return '已取消'
            }else if(status == 'used'|| status=='signed'){
                this.classobject="c9"
                return '已使用'
            }
        },
        signIn(id,status){
            //签卡,取消
            this.$http.post('club_user_reserve/changeStatus',{
                id:id,
                status: status,
                refusedReason:this.refusedReason
            }).then(res=>{
                this.item.status = status
            })
        },
        cancelSign(action,done){
            //取消预约
            if (action === 'confirm') {                
                this.$http.post('club_user_reserve/changeStatus',{
                    id:this.item.id,
                    status: 'canceled',
                    refusedReason:this.refusedReason
                }).then(res => {
                    if(!res.data.code){
                        Toast('已取消')
                        this.item.status = 'canceled'
                        setTimeout(done, 500)
                    }else{
                        Toast.fail(res.data.message)
                        setTimeout(done, 500)
                    }
                })              
            } else {
                done();
            }
        },
        tips(msg){
            Toast(msg);
        }
    }
}
</script>
<style lang="less" scoped>
@mg-default:.15rem;
.appointment-card{ 
    position: relative;
    min-height: 1rem;
    margin-top: .1rem;
    padding:.1rem; 
    font-size: .16rem; 
    background-color: #fff; 
    border-radius: .03rem; 
    box-shadow: rgba(0,0,0,.2) 0 0 .05rem; 
    color: #444;
    z-index: 1;
    &-body{
        position: absolute;
        top: @mg-default; left: @mg-default; right: @mg-default;
        z-index: 1;
        &__status{
            &--success{ 
                color: #68c864;
            }
            &--fail{ 
                color: #f00;
            }
        }
        &__info{
            position: absolute;
            left: 0.56rem;
            &>.name{
                width: 60%;
                overflow: hidden;
                text-overflow: ellipsis;
                height: .2rem;
            }
        }
        &__btn{
            position: absolute;
            top: 0;
            right: 0.05rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ReservedCardManage.vue